import { Modal, Button } from 'antd';
import { Form } from '@/components';
import { useTranslation } from 'react-i18next';
import {
  schema,
  PersonalizationItemFormContent,
  PersonalizationItemFormValue,
  AddPersonalizationItemFormValue,
  PersonalizationItemFormContentProps,
} from './PersonalizationItemFormContent';

interface Props extends PersonalizationItemFormContentProps {
  head?: React.ReactNode;
  onClose: () => any;
  onSubmit: (value: PersonalizationItemFormValue) => any;
  texts: {
    title: React.ReactNode;
    saveBtn: React.ReactNode;
    closeBtn?: React.ReactNode;
  };
}

export function PersonalizationItemDetailsModal(props: Props) {
  const { onClose, onSubmit, texts, initialValue: value, head } = props;
  const { t } = useTranslation();

  return (
    <Modal
      width={'50%'}
      title={texts.title}
      visible
      onCancel={onClose}
      footer={[
        <Button key="back" type="default" onClick={onClose}>
          {texts.closeBtn ?? t('personalization.item.details.cancelButton')}
        </Button>,
        <Form.Submit
          uid="personalization-item-details"
          key="submit"
          type="primary"
        >
          {texts.saveBtn}
        </Form.Submit>,
      ]}
    >
      {head}
      <Form.Formik<AddPersonalizationItemFormValue>
        uid="personalization-item-details"
        i18n="personalization.item.details"
        initialValues={{ ...value, __hasSuboptions: false }}
        validationSchema={schema}
        onSubmit={onSubmit}
      >
        <PersonalizationItemFormContent {...props} />
      </Form.Formik>
    </Modal>
  );
}
